export default __webpack_public_path__ + "static/media/ber.adb0b5ab.png";